import { UseLoadingReturn } from "@/hooks/use-loading";
import useUpdate from "@/hooks/use-update";
import { IWorkflowInput } from "@/interfaces/workflow.interface";
import workflowService from "@/services/workflow.service";
import { UpdateByIdProps } from "@/types/requests.types";

export type UpdateWorkflowProps = UpdateByIdProps<IWorkflowInput>;

export type UseUpdateWorkflowReturn = {
  update: (props: UpdateWorkflowProps) => Promise<void>;
} & UseLoadingReturn;

const useUpdateWorkflow = (): UseUpdateWorkflowReturn => {
  const {
    isLoading,
    startLoading,
    endLoading,
    loadingIcon,
    update: update,
  } = useUpdate<IWorkflowInput>({
    operation: (formData, workflowId) => workflowService.update(formData, workflowId),
  });

  return {
    isLoading,
    startLoading,
    endLoading,
    loadingIcon,
    update,
  };
};

export default useUpdateWorkflow;
